export default {
	'total-net': 'Net toplam',
	'show-all-journal': 'Tüm yevmiyeleri göster',
	'enter-quantity': 'Miktarı giriniz',
	'enter-item-by-barcode': 'Ürünün barkodunu giriniz',
	'paper-document': 'Kağıt belgeler',
	'addition-item': 'Ek öğe',
	'the-net-invoice-must-be-zero-and-this-requires-zeroing-all-financial-fields': 'Net fatura sıfır olmalıdır ve bu da tüm finansal alanların sıfırlanmasını gerektirir',

	'confirm-user': 'Kullanıcıyı onayla'
}